/**
 * @fileoverview GET handler for the "/companies/:company_id/developers_common" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import type { RootCacheKey } from "../types";
import { sparseDevelopersCacheKey } from "./constants";
import type { GetSparseDevelopersQueryParams, SparseDeveloper } from "./types";

type GetSparseDevelopersArgs =
  | [companyId: string]
  | [companyId: string, queryParams: GetSparseDevelopersQueryParams];

export const getSparseDevelopers = reactQueryFetcherAdapter<
  typeof sparseDevelopersCacheKey,
  readonly [rootKey: RootCacheKey<typeof sparseDevelopersCacheKey>, ...originalKey: GetSparseDevelopersArgs],
  GetSparseDevelopersArgs,
  SparseDeveloper[]
>(
  sparseDevelopersCacheKey,
  (signal: AbortSignal, ...[companyId, queryParams]: GetSparseDevelopersArgs): Promise<SparseDeveloper[]> => {
    return fetch(`/companies/${companyId}/developers_common`, "GET", queryParams, { signal });
  }
);
